// @flow

import { get, isEmpty, stubTrue } from 'lodash';

import {
  createAppAlternativesPageLink,
  createAppHelpPageLink,
  createAppIntegrationsPageLink,
  createAppOverviewPageLink,
  createAppTutorialsPageLink,
} from 'web-ssr/app/app-directory/utils';

import type { appDirectoryNavQuery } from 'web-ssr/graphql/types';

export type NavigationLink = {
  /** Returns the absolute URL of the navigation link */
  getHref: (appSlug: string) => string,
  /** The text to display as the navigation link */
  text: string,
  /** Conditionally display the navigation link */
  isVisible: (headerQueryResult: ?appDirectoryNavQuery) => boolean,
  /** Conditionally highlight the navigation link */
  isExact: boolean,
};

export const navigationLinks: Array<NavigationLink> = [
  {
    getHref: (appSlug: string) => createAppOverviewPageLink(appSlug),
    text: 'Overview',
    isVisible: data => Boolean(get(data, ['appBySlug', 'reviewPage'])),
    isExact: true,
  },
  {
    getHref: (appSlug: string) => createAppIntegrationsPageLink(appSlug),
    text: 'Integrations',
    isVisible: stubTrue,
    isExact: false,
  },
  {
    getHref: (appSlug: string) => createAppHelpPageLink(appSlug),
    text: 'Help',
    isVisible: data => !isEmpty(get(data, ['appSupportNotes'])),
    isExact: false,
  },
  {
    getHref: (appSlug: string) => createAppTutorialsPageLink(appSlug),
    text: 'Tutorials',
    isVisible: data => get(data, ['blogPostsV2', 'totalCount']),
    isExact: false,
  },
  {
    getHref: (appSlug: string) => createAppAlternativesPageLink(appSlug),
    text: 'Alternatives',
    isVisible: data =>
      get(data, ['appBySlug', 'appAlternatives', 'totalCount']),
    isExact: false,
  },
];
